import { useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useState } from "react";
import { Box, Button, Card, Tab, Tabs, Typography } from "@mui/material";

import moment from "moment";
// import CustomerDocuments from "../../../features/users/CustomerDocuments";
import { Details } from "../../../features";
// import { useLazyGetPerformanceInsightsQuery } from "../../../services/performace";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const PaymentDetails = () => {
  const location = useLocation();
  const { state } = location;

  const navigate = useNavigate();
  const [open, setOpen] = useState<boolean>(false);
  const { _id } = useParams();
  // const [getData] = useLazyGetPerformanceInsightsQuery();
  const [leadsSelectedTime, setLeadsSelectedTime] = useState("3");
  const [majorLineChartData, setMajorLineChartData] = useState<
    {
      name: string;
      count: number;
      emailCount: number;
      inAppChatCount: number;
      whatAppCount: number;
      phoneCount: number;
    }[]
  >([]);
  const [leadsSelectedApp, setLeadsSelectedApp] = useState("");

  const [displayTextData, setDisplayTextData] = useState<any>({
    whatsapp: {},
    phone: {},
    email: {},
    inApp: {},
  });
  const convertPieChartPercent = (
    data: { label: string; value: number; color: string }[]
  ) => {
    const total = data.reduce((accumulator, currentValue) => {
      return accumulator + Number(currentValue.value);
    }, 0);
    if (total === 0) return data;
    return data?.map((data2) => ({
      label: data2?.label,
      value: ((data2?.value / total) * 100).toFixed(2) || 0,
    }));
  };
  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const [pieChartData, setPieChartData] = useState<
    { label: string; value: number; color: string }[]
  >([]);
  const [barRankData, setBarRankData] = useState<any>({});

  const [overallGraphData, setOverallGraphData] = useState({
    listingsData: [
      { name: "Standard", value: 0, percentage: 0 },
      { name: "Featured", value: 0, percentage: 0 },
      { name: "Premium", value: 0, percentage: 0 },
    ],
    listingsDataTotal: 0,
    impressionsData: [
      { name: "Standard", value: 0, percentage: 0 },
      { name: "Featured", value: 0, percentage: 0 },
      { name: "Premium", value: 0, percentage: 0 },
    ],
    impressionsDataTotal: 0,
    clicksData: [
      { name: "Standard", value: 0, percentage: 0 },
      { name: "Featured", value: 0, percentage: 0 },
      { name: "Premium", value: 0, percentage: 0 },
    ],
    clicksDataTotal: 0,
  });

  

  return (
    <div>
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">View Payment Details</h1>
          <Button
            className="btn btn_primary"
            onClick={() => {
              navigate("/manage-Payments", { state: state?.tab });
            }}
          >
            Back
          </Button>
        </div>

        <Card className="cards">
          <Box className="custom_tabs">
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              {/* <Tab label="Manual Payouts" {...a11yProps(0)} /> */}
              <Tab label="Profile Details" {...a11yProps(0)} />

              {/* <Tab label="Customer ratings and reviews" {...a11yProps(4)} /> */}
              {/* <Tab label="Token History" {...a11yProps(3)} />
              <Tab label="Reels" {...a11yProps(4)} />
              <Tab label="Transactions" {...a11yProps(5)} /> */}
              {/* {state?.insights === true ? (
                <Tab label="Titan Insights" {...a11yProps(6)} />
              ) : (
                ""
              )}
              {state?.insights === true ? (
                <Tab label="Overall Performance" {...a11yProps(7)} />
              ) : (
                ""
              )}
              {state?.insights === true ? (
                <Tab label="Listing Performance" {...a11yProps(8)} />
              ) : (
                ""
              )}
              {state?.insights === true ? (
                <Tab label="Leads Insights" {...a11yProps(9)} />
              ) : (
                ""
              )} */}
              {/* {state?.insights === true ? <Tab label="Super Agent Criteria" {...a11yProps(10)} /> : ""} */}
            </Tabs>
            <CustomTabPanel value={value} index={0}>
              <Details />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              {/* <CustomerDocuments /> */}
            </CustomTabPanel>
          </Box>
        </Card>
      </div>
    </div>
  );
};

export default PaymentDetails;
